import { Box, Typography } from "@mui/material";
import PropTypes from "prop-types";
import {
  colorsFoundation,
  dimensions,
  typographyTokens,
} from "@accredo/fe-shared/theme/index.js";
import { getEnv } from "@accredo/fe-shared/env.js";

const EnvironmentBanner = ({ short = false }) => {
  const app_env = getEnv("VITE_APP_ENV") || "production";
  const app_env_name = getEnv("VITE_APP_ENV_NAME") || "Produktiv";

  if (app_env === "production") {
    return null;
  }

  return (
    <Box
      sx={{
        backgroundColor: colorsFoundation.status.negative[600],
        color: "white",
        textAlign: "center",
        padding: short ? dimensions["xl"] : "4px",
        width: "100%",
        height: short ? "auto" : "32px",
      }}
    >
      <Typography variant="subtitle2" component="p" sx={{ fontSize: "12px" }}>
        {short ? (
          <Box
            component="span"
            sx={{
              fontWeight: typographyTokens.weight.bold,
              fontSize: typographyTokens.size.sm,
            }}
          >
            {`${app_env_name}-Umgebung`}
          </Box>
        ) : (
          <>
            Sie arbeiten in der{" "}
            <Box
              component="span"
              sx={{
                fontWeight: typographyTokens.weight.bold,
                fontSize: typographyTokens.size.sm,
              }}
            >
              {`${app_env_name}-Umgebung`}
            </Box>
            . NICHT FÜR DEN PRODUKTIVEN EINSATZ.
          </>
        )}
      </Typography>
    </Box>
  );
};

EnvironmentBanner.propTypes = {
  short: PropTypes.bool,
};

export default EnvironmentBanner;
